/**
 * TOP 
 * .frontPage__eventContentBoxMainItem--map__mainListItemLink
 */

export module EventContentBoxMainItemMapMainListItemLinkModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $form = document.querySelector<HTMLElement>('.frontPage__eventContentBoxMainItem--formContent form');
      const $links = document.querySelectorAll<HTMLElement>('.frontPage__eventContentBoxMainItem--map__mainListItemLink');
      if ($form) {
        const $areaFormItem = $form.querySelector<HTMLInputElement>('[name="エリア"]');
        if ($areaFormItem) {
          $links.forEach(($link) => {
            const $value = $link.getAttribute('data-value');
            if ($value) {
              $link.addEventListener('click', ($event) => {
                $event.preventDefault();
                $areaFormItem.value = $value;

                let $EVENT;
                try {
                  $EVENT = new Event('change');
                } catch (e) {
                  $EVENT = document.createEvent('change');
                  $EVENT.initEvent('readCompleteAction', false, true);
                }
                $areaFormItem.dispatchEvent($EVENT);

                return false;
              });
            }
          });
        }
      }
    }
  }
}

